import { useTranslations } from "next-intl";

/** The logo symbol plus wordmark; the wordmark is `web.home.brand`. */
const BrandLockup = () => {
  const t = useTranslations("web.home");
  return (
    <span
      className="brand-lockup"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        height: "24px",
      }}
    >
      <img
        className="brand-lockup__symbol"
        src="/static/reflect/ReflectLogo.svg"
        alt=""
        aria-hidden="true"
        style={{
          display: "block",
          width: "auto",
          height: "24px",
        }}
      />
      <span
        className="brand-lockup__text"
        style={{
          color: "#002428",
          fontFamily: "Inter, sans-serif",
          fontSize: "24px",
          fontWeight: 500,
          lineHeight: "24px",
          whiteSpace: "nowrap",
        }}
      >
        {t("brand")}
      </span>
    </span>
  );
};

export default BrandLockup;
